module.exports = __webpack_public_path__ + "img/clock.d3f05d14.svg";